import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

import {WorkspaceItem} from 'constants/FileBrowserConstants';
import ClickOutWrapper from 'ui-library/ClickOutWrapper';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

import {ClearWorkspaceActionType} from './WorkspaceConstants';
import WorkspaceItemTab from './WorkspaceItemTab';

interface WorkspaceTabDropdownProps {
  openFile: (fileId: string) => void;
  onClearWorkspace: (action: ClearWorkspaceActionType, itemId?: string) => void;
  activeId: string | null;
  overflowItems: Array<WorkspaceItem>;
}

interface State {
  isOpen: boolean;
}

class WorkspaceTabDropdown extends React.Component<WorkspaceTabDropdownProps> {
  state: State = {
    isOpen: false,
  };

  _handleToggleDropdown = (): void => {
    this.setState({isOpen: !this.state.isOpen});
  };

  _handleCloseDropdown = (): void => {
    if (this.state.isOpen) {
      this.setState({isOpen: false});
    }
  };

  _handleDragStart = (e: ElementMouseEvent, index: number): void => {
    // Open the file and move overflow item to be the leftmost tab.
    const {openFile, overflowItems} = this.props;
    openFile(overflowItems[index].fileId);
    this._handleCloseDropdown();
  };

  render(): JSX.Element {
    const {activeId, onClearWorkspace, overflowItems} = this.props;
    const {isOpen} = this.state;
    const overflowTabs = overflowItems.map((workspaceItem, index) => (
      <WorkspaceItemTab
        item={workspaceItem}
        isOverflowTab={true}
        isLastTab={false}
        forceMinWidth={false}
        onDragStart={this._handleDragStart}
        onClearWorkspace={onClearWorkspace}
        index={index}
        isActive={activeId === workspaceItem.fileId}
      />
    ));

    const isActiveTabInOverflow = _.any(overflowItems, (item) => item.fileId === activeId);

    // Use bootstrap dropdown CSS classes, but directly control the "open" style since we want to
    // keep the dropdown open while it's being interacted with.
    return (
      <span className="workspace-overflowIcon fatDropdown workspace-overflowMenu">
        <ClickOutWrapper shouldCloseOnInsideClick={false} onClickOut={this._handleCloseDropdown}>
          <div className={classNames('buttonGroup', {open: isOpen})}>
            <div
              className={classNames('moreDropdownBtn', {active: isActiveTabInOverflow || this.state.isOpen})}
            >
              <BenchlingIcon icon="overflow" onClick={this._handleToggleDropdown} />
            </div>
            <ul className="dropdown-menu pull-right workspace-overflowDropdown">
              <div className="workspace-overflowDropdown-scrollContainer">
                {overflowTabs.map((tab, i) => (
                  <li key={i}>{tab}</li>
                ))}
              </div>
              <li className="divider" />
              <li
                className="workspace-itemTab"
                onClick={() => {
                  this.props.onClearWorkspace(ClearWorkspaceActionType.CLOSE_ALL);
                }}
              >
                <span className="workspace-itemTab-closeAll">Close All Tabs</span>
              </li>
            </ul>
          </div>
        </ClickOutWrapper>
      </span>
    );
  }
}

export default WorkspaceTabDropdown;
